import type { FieldMapping, RoleMapping } from './types'

export function normalizeFieldMappings(
	fMappings: { sourceField: string; targetField: string; transform?: string | null }[],
): FieldMapping[] {
	return fMappings.map((m) => ({
		crmField: m.sourceField,
		viaPeopleField: m.targetField,
		transform: m.transform || '',
	}))
}

export function parseRoleMappings(crmRoleMappings: unknown[]): RoleMapping[] {
	return crmRoleMappings.filter(
		(m): m is RoleMapping =>
			typeof m === 'object' &&
			m !== null &&
			typeof (m as RoleMapping).crmRoleValue === 'string' &&
			typeof (m as RoleMapping).roleId === 'string' &&
			typeof (m as RoleMapping).formId === 'string',
	)
}
